class EventManager {
    eventMapper: any[] = [];
    hostInstance: any;
    constructor(host: any) {
        this.hostInstance = host;
    }

    addEventListener(querySelector: any, event: any, cb: any, hostele: any) {
        try {
            if (!hostele) {
                if (this.eventMapper.filter((el: any) => el.querySelector === querySelector && el.event == event).length) {
                    return;
                }
            }
            this.eventMapper.push({ querySelector, event, cb });
            let hostElement = hostele ? hostele : this.hostInstance.chatEle;
            hostElement.querySelector(querySelector)?.addEventListener(event, cb);
        } catch (err) {
            console.log("Event listener error:", err);
        }
    }

    removeEventListener(querySelector: any, event: any, hostele: any) {
        try {
            const ele = this.eventMapper.filter((el: any) => el.querySelector == querySelector && el.event == event);
            let hostElement = hostele ? hostele : this.hostInstance.chatEle;
            hostElement.querySelector(querySelector)?.removeEventListener(event, ele[0]?.cb);
            this.eventMapper.splice(this.eventMapper.findIndex((el: any) => el.querySelector == querySelector && el.event == event), 1);
        } catch (err) {
            console.log("Event listener remove error:", err);
        }
    }
}   

export default EventManager;
